import { distanceIntervaled } from "./common/intervaled.js";
import { radios } from "../api/api.js";

const MINIMUM_DISTANCE_INTERVAL_METERS = 10000;

const radio = distanceIntervaled(
	MINIMUM_DISTANCE_INTERVAL_METERS,

	([$journey], set) => {
		if (!$journey.location) {
			return;
		}

		radios($journey.location)
			.then(({ radios }) => {
				set(radios);
			})
			.catch((error) => {
				set([]);
			});
	}
);

export default radio;
